import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What a 3:36 marathon does to your body",
  "description": "",
  "published": "2018-07-30T00:00:00.000Z",
  "redirect_from": ["/blog/336-marathon/swizec/8538"],
  "categories": "Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I tried so hard to sprint over the finish line, but nothing happened. I gave it my all and there was no more to give.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`It wasn’t 3:30 but I gave it my all 💪Hope I’m smart enough to never do this again 🤞 `}<a parentName="p" {...{
          "href": "https://t.co/uJNgusZEMz"
        }}>{`https://t.co/uJNgusZEMz`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/Id20mBWbPQ"
        }}>{`pic.twitter.com/Id20mBWbPQ`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1023604991653605376"
      }}>{`July 29, 2018`}</a></blockquote>
    <p>{`That morning started at 4:30am. Really, it started the night before. I prepared all my gear. Best not to get flustered when you're rushing to be at the start line by 5:20am.`}</p>
    <p>{`It's a 20-minute walk from my place to the marathon. Perfect to warm up and loosen up your legs. I also like to give it a light jog from gear drop-off to my corral.`}</p>
    <p>{`You'll be cold after the marathon. Tired, wet, exhausted. You need dry clothes to keep warm. Some food and water is great.`}</p>
    <p>{`So you bring a change of clothes and some knickknacks in a bag. You write down your name and leave it at gear drop-off. A long row of UPS trucks.`}</p>
    <h2 {...{
      "id": "and-then-you-get-ready"
    }}>{`And then you get ready`}</h2>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`It’s early `}<a parentName="p" {...{
          "href": "https://t.co/JHJFSPKjcY"
        }}>{`pic.twitter.com/JHJFSPKjcY`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1023544074521915399"
      }}>{`July 29, 2018`}</a></blockquote>
    <p>{`Marathon start lines are broken into corrals. For crowd control.`}</p>
    <p>{`Some 27,500 people ran the `}<a parentName="p" {...{
        "href": "http://www.thesfmarathon.com/"
      }}>{`San Francisco Marathon`}</a>{`. That many people in a long narrow corridor is the perfect recipe for a `}<a parentName="p" {...{
        "href": "https://www.news.com.au/technology/science/human-body/crowd-crush-what-happens-in-a-human-stampede/news-story/5ea6cd28dfc8744246e0bdd5500baa11"
      }}>{`crowd crush`}</a>{`.`}</p>
    <p>{`Best way to prevent those is to break the area into corrals and have people start in groups with a few minutes in between. That way nobody gets trampled, and people are grouped with others who are running aiming for a similar race time. Everyone is happier.`}</p>
    <p>{`You take off your sweater and donate it to the marathon. Bye bye, sweater. I'll never see you again.`}</p>
    <p>{`The cable car bell rings. You waddle to the start line. Start your running app and away you go.`}</p>
    <h2 {...{
      "id": "and-then-you-run"
    }}>{`And then you run`}</h2>
    <p>{`There's nothing special to running a marathon. You put one foot in front of the other for 26.2 miles, 42.2 kilometers.`}</p>
    <p>{`Mostly, it's just kind of miserable. First person to run a marathon died from exhaustion.`}</p>
    <lite-youtube {...{
      "videoid": "O8ElNO4bBCQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`👆 That's my insta story from the marathon. Read the pain in my eyes.`}</p>
    <p>{`To survive a marathon, some say you should eat – some prefer not to. Some say you should drink – some say to load up on electrolytes the night before.`}</p>
    <p>{`Salt retains water. The more water you retain, the less you need to drink.`}</p>
    <p>{`I like to eat a running gel (I like Gu) every 10 kilometers and drink water with electrolytes (I like Nuun) whenever the mood strikes me. Best to listen to your body.`}</p>
    <p>{`Everything includes lots of caffeine. Caffeine increases stamina, reduces pain, and gives you a mental boost.`}</p>
    <p>{`Placebo or not, it doesn't matter. As long as it improves your time and helps you finish. Marathons are a mental game as much as they are physical.`}</p>
    <h2 {...{
      "id": "what-happens-to-your-body"
    }}>{`What happens to your body`}</h2>
    <p>{`A marathon is brutal on your body. Anyone who tells you it's healthy to run a marathon is an idiot.`}</p>
    <p>{`Take your heart, for example. Max heart rate for a 30 year old, me, is 180. 210 minus age.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The maximum heart rate (HRmax) is the highest heart rate an individual can achieve without severe problems through exercise stress`}</p>
      <p parentName="blockquote">{`/../ the most accurate way of measuring any single person's HRmax is via a cardiac stress test.`}</p>
      <p parentName="blockquote">{`/../ perform this test only in the presence of medical staff due to risks associated with high heart rates`}</p>
    </blockquote>
    <p>{`My `}<em parentName="p">{`average`}</em>{` heart rate during the marathon? 174`}</p>
    <p>{`Max? 196`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/07/DjSeSqcVsAEUnSt.jpg",
        "alt": null
      }}></img></p>
    <p>{`That's 16 beats per minute over my theoretical max. Overall, I spent 70% of the time, two and a half hours, in the anaerobic zone.`}</p>
    <p>{`You're supposed to use that zone for short bursts during high intensity interval training.`}</p>
    <p>{`At times, it felt like my legs were ripping themselves apart. My muscles didn't burn, oh no, it felt like my quadriceps was literally ripping themselves from my knee.`}</p>
    <p>{`Fun stuff.`}</p>
    <p>{`I started that day at 56.9kg (125.4lbs) and 11.9% bodyfat. After the marathon, I was at 55.7kg (122.7lbs) and 11.5% bodyfat.`}</p>
    <p>{`That means I lost 0.3kg (0.7lbs) of pure fat in a single run. Just over a whole kilogram overall. That might not sound impressive to you, but if you ever tried to diet, you'll know how hard it is to drop body fat percentages.`}</p>
    <h2 {...{
      "id": "and-then-you-finish"
    }}>{`And then you finish`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/07/biofreeze-san-francisco-marathon-r6fbytm4.png",
        "alt": "Official marathon time 3h 36m 40s"
      }}></img></p>
    <p>{`You're done. Your legs don't work. Your mind is a blur. Did that really just happen? You ran for almost four hours straight. What the hell is wrong with you?`}</p>
    <p>{`My legs locked up, so I had to sit down. Then I couldn't move for 20 minutes. At least the view of the bay and the Bay Bridge was nice.`}</p>
    <p>{`I reflected on my time.`}</p>
    <p>{`It wasn't what I wanted, 3hr 30min, but it was the best time I could get with my casual approach to training. The race itself went perfect. Nothing more I could've done.`}</p>
    <p>{`But hey, if this were the first modern Olympic marathon in 1904, I would've got bronze. So there's that.`}</p>
    <p>{`Eventually, I made it over to my gear, got dressed, and waddled my way back home. Shivering the whole time despite the warm weather and my cozy clothes.`}</p>
    <p>{`There just wasn't any energy left to keep me warm.`}</p>
    <h2 {...{
      "id": "and-then-you-eat"
    }}>{`And then you eat`}</h2>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`And now the best part of marathon running 👇 `}<a parentName="p" {...{
          "href": "https://t.co/XvbctWZJp3"
        }}>{`pic.twitter.com/XvbctWZJp3`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1023649173571166208"
      }}>{`July 29, 2018`}</a></blockquote>
    <p>{`The best part of all the running and the training is the food you get to eat. In ridiculous quantities.`}</p>
    <p>{`On a normal day with no exercise, I am meant to consume 1740 calories. That's my base metabolic rate. Enough to keep my brain working, enable me to move, and stay warm. Without losing weight.`}</p>
    <p>{`To put 1740 calories in perspective, `}<a parentName="p" {...{
        "href": "https://www.verywellfit.com/two-meal-plans-for-a-1700-calorie-per-day-diet-2506565"
      }}>{`here is what a good menu would look like`}</a>{`.`}</p>
    <p>{`Or you can think of it as 2 proper hamburger meals at a pub.`}</p>
    <p>{`During the marathon, I burned some 3000 calories. Almost twice my normal daily allotment of food.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/07/FullSizeRender-1.jpg",
        "alt": null
      }}></img></p>
    <p>{`If you don't eat it all back, you won't be able to walk the next morning. And yes, I put a lot of practice into being able to get through that much food in a single day.`}</p>
    <p>{`4500 calories I ate.`}</p>
    <p><strong parentName="p">{`Breakfast`}</strong>{` 1167 calories (includes running stuff)`}</p>
    <ul>
      <li parentName="ul">{`RxBar`}</li>
      <li parentName="ul">{`Rx nut butter`}</li>
      <li parentName="ul">{`4 Gu gels`}</li>
      <li parentName="ul">{`Kind Crunchy Peanut Butter Bar`}</li>
      <li parentName="ul">{`Banana`}</li>
      <li parentName="ul">{`Chai latte`}</li>
    </ul>
    <p><strong parentName="p">{`Lunch`}</strong>{` 1440 calories`}</p>
    <ul>
      <li parentName="ul">{`1.7 scoops Quest protein`}</li>
      <li parentName="ul">{`2 cups almond milk`}</li>
      <li parentName="ul">{`2 slices bacon`}</li>
      <li parentName="ul">{`5 duck eggs`}</li>
      <li parentName="ul">{`1 roasted chicken patty from TJ`}</li>
      <li parentName="ul">{`1 bread roll`}</li>
      <li parentName="ul">{`2 potatoes`}</li>
      <li parentName="ul">{`1 large peach roasted`}</li>
    </ul>
    <p><strong parentName="p">{`2nd lunch`}</strong>{` 690 calories`}</p>
    <ul>
      <li parentName="ul">{`rye bread roll`}</li>
      <li parentName="ul">{`pickles`}</li>
      <li parentName="ul">{`salami`}</li>
      <li parentName="ul">{`coconut water`}</li>
      <li parentName="ul">{`banana`}</li>
      <li parentName="ul">{`square of chocolate`}</li>
      <li parentName="ul">{`large apple`}</li>
    </ul>
    <p><strong parentName="p">{`Dinner`}</strong>{` ~1000 calories`}</p>
    <ul>
      <li parentName="ul">{`sweet potato fries`}</li>
      <li parentName="ul">{`lettuce wrap fried chicken sandwich`}</li>
      <li parentName="ul">{`ranch dressing`}</li>
      <li parentName="ul">{`glass of beer`}</li>
      <li parentName="ul">{`TJ almond matcha latte mix`}</li>
      <li parentName="ul">{`cup of ice cream`}</li>
    </ul>
    <p>{`Yes, I pooped 5 or 6 times 💩`}</p>
    <p>{`And today, I weigh 58kg (127.8lbs).`}</p>
    <p>{`So, you know, next time you gain or lose 5 pounds, don't worry about it. Easy to achieve those swing.`}</p>
    <p>{`Now let's hope I'm smart enough never to do that again.`}</p>
    <p>{`✌️`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      